const displayPrice = (amount) => {
  const st = '' + (amount / 100)
  let [ pounds, pence ] = st.split('.')
  pence = pence || ''
  while(pence.length < 2) {
    pence += '0'
  }
  return `${pounds}.${pence}`
}

const utils = {
  displayPrice,
}

export default utils